import moment from 'moment';
import { getCurrentDate } from '../../services/DateTime/DateTime';

export const resolveClaim = (claims, resolvedClaimId) => {
  return claims.map(claim => {
    if (resolvedClaimId === claim.id) {
      return {
        ...claim,
        active: true,
        resolved: true,
        resolvedDate: new Date()
      };
    }
    return claim;
  });
};

export const deleteClaim = (claims, resolvedClaimId) => {
  return claims.map(claim => {
    if (resolvedClaimId === claim.id) {
      return {
        ...claim,
        active: false,
        resolved:false
      };
    }
    return claim;
  });
};

export const applyFieldFilter = ({list, field, value}) => {
  return list.filter(element =>  element[field] ? element[field]  === value : value ===false );
};

export const mapClaimsToClaimCardData = claims => {
  return claims.map(claim => {
  const {
      id,
      created,
      active,
      ...data
  } = claim;
  return {
      id,
      expanded: false,
      data: {
        ...data,
        date: moment(created).format('DD.MM.YYYY'),
        time: moment(created).format('HH:mm'),
        daysPast: moment(getCurrentDate()).endOf('day').diff(created, 'days'),
      },
  };
  });
};

export const toggleCardExpansion = (expandedCardList, claimCardId) => {
  if (expandedCardList.findIndex(id => id === claimCardId) !== -1) {
    return expandedCardList.filter(id => id !== claimCardId);
  }
  return [
    ...expandedCardList,
    claimCardId,
  ];
};

export const getClaimCardsData = ({claims, expandedCardList = [], countyFilter, reasonFilter}) => {
  let filteredClaims = claims ? claims : [];
  filteredClaims = applyFieldFilter({list: filteredClaims, field: 'active', value: true});
  
  filteredClaims = applyFieldFilter({list: filteredClaims, field: 'resolved', value: false});
  
  if (countyFilter !== 'all') {
    filteredClaims = applyFieldFilter({list: filteredClaims, field: 'county', value: countyFilter});
  }
  if (reasonFilter !== 'Toate') {
    filteredClaims = applyFieldFilter({list: filteredClaims, field: 'reason', value: reasonFilter});
  }
  
  let claimCardsData = mapClaimsToClaimCardData(filteredClaims);
  claimCardsData = claimCardsData.map(claimCard => {
    if (expandedCardList.findIndex(id => id === claimCard.id) !== -1) {
      return {
        ...claimCard,
        expanded: true,
      };
    }
    return claimCard;
  });
  return claimCardsData;
};